import React, { useCallback, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import data from "../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { GridLayout } from "../common/GridLayout";
import * as PermissionsConstants from "../const/constants.js";
import { Button } from 'devextreme-react/button';
import { useHistory } from 'react-router-dom';
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar,
  Item,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import "jspdf-autotable";
import "../dbl/css/dashboard.css";
const SearchDashboard = (props) => {
  var accessToken = props.oidc.user.access_token;
  var permissions = props.ReceiptReducer.rolePermissions;
  const history = useHistory();
  const [createButtonDisable, setCreateButtonDisable] = useState(true);
  const [editButtonDisable, setEditButtonDisable] = useState(true);
  const [delDisable, setDelDisable] = useState(true);

  const canCreateDashboard = permissions.DBL?.includes(PermissionsConstants.CreateDashboardRole);
  const canUpdateDashboard = permissions.DBL?.includes(PermissionsConstants.UpdateDashboardRole);
  const canDeleteDashboard = permissions.DBL?.includes(PermissionsConstants.DeleteDashboardRole);
  const createButtonRef = useRef(null);
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);
  const rowId = useRef(null);
  const toggleButton = (disable) => {
    if (editButtonRef.current) {
      editButtonRef.current.disabled = disable;
      editButtonRef.current.onclick = handelEditClick;
    }
  };
  const handelDeleteClick = () => {
    const buttonUrl = "/dbl/delete-dashboard?id=" + rowId.current;
    history.push(buttonUrl);
  };
  const handelEditClick = () => {
    const buttonUrl = "/dbl/update-dashboard?id=" + rowId.current;
    history.push(buttonUrl);
  };
  const handelCreateClick = () => {
    const buttonUrl = "/dbl/create-dashboard";
    history.push(buttonUrl);
  };
  const toggleViewButton = (disable) => {
    if (deleteButtonRef.current) {
      deleteButtonRef.current.disabled = disable;
      setEditButtonDisable(disable);
      deleteButtonRef.current.onclick = handelDeleteClick;
    }
  };
  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length > 0) {
      rowId.current = selectedRowsData[0].rowid;
      setDelDisable(false);
    } else {
      rowId.current = '';
      setDelDisable(true);
    }
    if (editButtonRef.current) {
      if (canUpdateDashboard) {
        toggleButton(!editButtonRef.current.disabled);
      }
    }
    if (deleteButtonRef.current) {
      if (canDeleteDashboard) {
        toggleViewButton(!deleteButtonRef.current.disabled);
      }
    }
  };
  const gridKey = "bedf4edf-7a7b-4e48-9902-64fa3e787fee";
    const [currentLayout, setCurrentLayout] = useState("Default");

  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const detailDataGrid = useRef(null);
  const fetchData = (accessToken) => {
    const resultData = createStore({
      key: ['rowid'],
      loadParams:
      {
        dashboardName: function () {
          return "";
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${data.DBL.SearchDashboard}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    return resultData;
  }

  useEffect(() => {
    if (canCreateDashboard) {
      setCreateButtonDisable(false);
    } else {
      setCreateButtonDisable(true);
    }
    const resultData = fetchData(accessToken);
    detailDataGrid.current.instance().option("dataSource", resultData);
  }, []);
  return (
    <div>
      <div className="header" style={{
        marginBottom: "20px",
      }}>
        <div className="title">
          <h6
            style={{
              marginLeft: "12px",
              color: window._env_.Color2
            }}
          >
            Search Dashboard Lite
          </h6>
        </div>
      </div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={detailDataGrid}
        allowColumnReordering={true}
        allowColumnResizing={true}
        showBorders={true}
        hoverStateEnabled={true}
        onSelectionChanged={(e) => onSelectionChanged(e)}
        className="ATConfigurationGridStyle"
        searchExpr="status"
        remoteOperations={true}
        searchEnabled={true}
        columnAutoWidth={true}
        scrolling={{ mode: "standard" }}
      >
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} />
        <Selection mode="multiple" />
        <Sorting visible={true} mode="multiple" />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter enabled={true} visible={false} />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Scrolling rowRenderingMode="virtual" />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <Scrolling mode="virtual" />
        <Column dataField="layoutname" caption='Dashboard Name' ></Column>
        <Column dataField="comment" caption='Base Query' ></Column>
        <Toolbar>
          <Item location="before">
            {(canDeleteDashboard) ? (
              <Button
                disabled={delDisable}
                type="default"
                text="Delete"
                onClick={handelDeleteClick}
              >
              </Button>
            ) : (
              <Button
                disabled={true}
                type="default"
                text="Delete"
              >
              </Button>
            )}
          </Item>
          <Item location="before">
            {(canUpdateDashboard) ? (
              <Button
                disabled={delDisable}
                type="default"
                text="Edit"
                onClick={handelEditClick}
              >
              </Button>

            ) : (
              <Button
                disabled={true}
                type="default"
                text="Edit"
              >
              </Button>
            )}
          </Item>
          <Item location="before">
            {(canCreateDashboard) ? (
              <Button
                disabled={createButtonDisable}
                type="default"
                text="Create"
                onClick={handelCreateClick}
              >
              </Button>

            ) : (
              <Button
                disabled={true}
                type="default"
                text="Create"
              >
              </Button>

            )}
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>
      </DataGrid>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(SearchDashboard);